import { Table } from '@mantine/core';
import type { UseQueryResult } from 'react-query';
import { DataTable } from '../../../components/DataTable';
import { usePagination } from '../../../hooks/usePagination';
import type { FilterDto } from '../../../util/types/FilterDto';
import type { ApiResponse } from '../../../util/types/Response';
import type { AttendanceDto } from '../types/AttendanceDto';
import { IndividualAttendanceHeaders } from './IndividualAttendanceHeaders';
import { IndividualAttendanceRow } from './IndividualAttendanceRow';

interface GroupedAttendanceProps {
	filter: FilterDto;
	refreshTables: () => void;
	attendanceCountQuery: UseQueryResult<ApiResponse<number>, unknown>;
	attendanceQuery: UseQueryResult<ApiResponse<AttendanceDto[]>, unknown>;
}

export function IndividualAttendanceTable({
	filter,
	refreshTables,
	attendanceCountQuery,
	attendanceQuery,
}: GroupedAttendanceProps) {
	const pagination = usePagination();

	return (
		<>
			<DataTable
				pagination={pagination}
				totalItems={attendanceCountQuery.data?.value}
				isRowsLoading={attendanceQuery.isLoading}
				isPaginationLoading={attendanceCountQuery.isLoading}
				rows={pagination.value.pageSize}
				columnSpan={9}
				minHeight="66vh"
				maxHeight="76vh"
			>
				<IndividualAttendanceHeaders />
				<Table.Tbody>
					{attendanceQuery.data?.value.map((attendance) => (
						<IndividualAttendanceRow
							initialAttendance={attendance}
							key={attendance.id}
							refreshTables={refreshTables}
						/>
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
